import h from "./html";
import Db from "./db";
import Connections from "./Connections";
import Admin from "./Admin";
import SqlDebug from "./SqlDebug";

export default function Settings({ db }: { db: Db }) {
  const isAdmin = db.query(
    /*sql*/ `SELECT count(1) FROM admin INNER JOIN me USING (user_id)`,
    ["isAdmin"],
    [],
  );
  return (
    <div className="flex flex-col p-4 w-full">
      <Connections db={db} />
      {process.env.NODE_ENV === "production" ? "" : <SqlDebug db={db} />}
      {() =>
        isAdmin.val instanceof Array && isAdmin.val[0]?.isAdmin ? (
          <Admin db={db} />
        ) : (
          ""
        )
      }
      <h2 className="text-xl mb-2 font-bold">Account</h2>
      <button
        className="p-2 bg-red-500 hover:bg-red-300 text-red-50 border-red-400 border-2 rounded-md px-8 disabled:bg-fairy-300 w-32"
        onclick={async (ev) => {
          ev.preventDefault();
          db.login("", "");
        }}
      >
        Logout
      </button>
      <div className="grow" />
    </div>
  );
}
